"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwCheckBox = _interopRequireDefault(require("./CwCheckBox.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var CwCheckBox =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwCheckBox, _React$Component);

  function CwCheckBox() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CwCheckBox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CwCheckBox)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", function () {
      if (_this.props.disabled || !_this.props.onChange) {
        return;
      }

      _this.props.onChange(!_this.props.value);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyPress", function (event) {
      if (_this.props.disabled || !_this.props.onChange || event.which !== 32) {
        return;
      }

      _this.props.onChange(!_this.props.value);
    });
    return _this;
  }

  (0, _createClass2.default)(CwCheckBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        this.wrap.focus();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.onComponentDidUpdate) {
        this.props.onComponentDidUpdate(this.props.value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _cx,
          _cx2,
          _this2 = this;

      var _this$props = this.props,
          disabled = _this$props.disabled,
          value = _this$props.value,
          invalid = _this$props.invalid;
      var controlClass = (0, _classnames.default)((_cx = {}, (0, _defineProperty2.default)(_cx, _CwCheckBox.default.controlInvalid, invalid && !disabled), (0, _defineProperty2.default)(_cx, _CwCheckBox.default.controlDisabled, disabled), (0, _defineProperty2.default)(_cx, _CwCheckBox.default.control, !disabled), _cx));
      var checkboxClass = (0, _classnames.default)((_cx2 = {}, (0, _defineProperty2.default)(_cx2, _CwCheckBox.default.checkboxCheckedDisabled, disabled && value), (0, _defineProperty2.default)(_cx2, _CwCheckBox.default.checkboxDisabled, disabled && !value), (0, _defineProperty2.default)(_cx2, _CwCheckBox.default.checkboxChecked, !disabled && value), (0, _defineProperty2.default)(_cx2, _CwCheckBox.default.checkbox, !disabled && !value), (0, _defineProperty2.default)(_cx2, _CwCheckBox.default.checkboxCheckedInvalid, !disabled && invalid && value), (0, _defineProperty2.default)(_cx2, _CwCheckBox.default.checkboxInvalid, !disabled && invalid && !value), _cx2));
      return _react.default.createElement("div", {
        "data-cwid": this.props.cwId,
        className: (0, _classnames.default)(_CwCheckBox.default.wrap, this.props.className),
        disabled: this.props.disabled,
        tabIndex: this.props.disabled ? -1 : this.props.tabIndex,
        readOnly: this.props.readOnly,
        ref: function ref(input) {
          return _this2.wrap = input;
        },
        onKeyPress: this.handleKeyPress,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        onClick: this.handleClick,
        style: this.props.style
      }, _react.default.createElement("div", {
        id: this.props.id,
        className: controlClass
      }, _react.default.createElement("div", {
        id: this.props.id,
        className: checkboxClass
      }), this.props.text ? _react.default.createElement("label", {
        id: this.props.id
      }, this.props.text) : null));
    }
  }]);
  return CwCheckBox;
}(_react.default.Component);

CwCheckBox.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Text next to checkbox
   */
  text: _propTypes.default.string,

  /**
   * Callback function when checkbox value is changed
   */
  onChange: _propTypes.default.func,

  /**
   * Used to check a checkbox
   */
  value: _propTypes.default.bool,

  /**
   * Can be used to disable checkbox
   */
  disabled: _propTypes.default.bool,

  /**
   * Unique id to be passed to event handlers
   */
  id: _propTypes.default.string,

  /**
   * Used to control tab order
   */
  tabIndex: _propTypes.default.number,

  /**
   * Used to control if checkbox is autofocused when the page loads
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes.default.func,

  /**
   * Used to display invalid state
   */
  invalid: _propTypes.default.bool,

  /**
   * Callback function that is fired when the component is updated
   */
  onComponentDidUpdate: _propTypes.default.func,

  /**
   * Override the styles of the root element
   */
  style: _propTypes.default.object,

  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes.default.string
};
CwCheckBox.defaultProps = {
  tabIndex: 0
};
var _default = CwCheckBox;
exports.default = _default;